<div class="container-md px-3 px-md-0 mt-3 mt-md-0">
  <!-- info banner (ticket 27756) -->
  <app-dashboard-info-banner
    [lastSurveyDate]="(latestSubmissionDetails$ | async)?.createdAt ?? null"
    [lastWeightDate]="(timeSnap$ | async)?.timestamp ?? null"
  ></app-dashboard-info-banner>

  <!-- title -->
  <h2 class="text-color mb-2">{{ 'dashboard.title' | translate }}</h2>
  <p
    class="text-muted link-small px-4 text-center fst-italic"
    [innerHTML]="'dashboard.feedback' | translate"
  >
    Der digitale Ernährungsbegleiter soll noch besser werden – mit Deiner Hilfe. Was funktioniert
    gut? Was fehlt Dir? 👉 Schreib uns: kontakt@ernaehrungsbegleiter.de
  </p>

  <ng-container *ngIf="vm$ | async as vm">
    <!-- Deine aktuelle Ernährungssituation (moved to top; ticket 27757) -->
    <div class="mt-2 card border-0">
      <app-flow-situation-card
        [user]="vm.user"
        [bmi]="vm.bmi"
        [weightChangePercentage]="vm.weightChangePercentage"
        [timeSnap]="vm.timeSnap"
        [scoreDetails]="vm.scoreDetails"
        [latestSubmissionDate]="vm.latestSubmissionDetails?.createdAt ?? null"
      ></app-flow-situation-card>
      <!-- blue info link moved from the removed "Bleib auf dem richtigen Kurs" card -->
      <div class="mb-3 text-center">
        <a href="/faq#dateneingabe" target="_blank" rel="noopener" class="btn-link link-small">
          {{ 'dashboard.links.dateneingabe' | translate }}
        </a>
      </div>
    </div>

    <div class="card box mt-2 px-4">
      <app-nutrition-goals
        class="px-4"
        [user]="vm.user!"
        [bmi]="vm.bmi"
        [timeSnap]="vm.timeSnap!"
        [weightChangePercentage]="vm.weightChangePercentage!"
      ></app-nutrition-goals>
      <div class="w-100 pb-1 text-center">
        <button
          class="col-12 col-lg-6 btn btn-secondary btn-lg"
          (click)="handleOpenWeightModalClick()"
        >
          {{ 'dashboard.weight_chart.check_weight_cta_label' | translate }}
        </button>
      </div>

      <div class="mb-3 text-center">
        <a href="/faq#gewicht" target="_blank" rel="noopener" class="btn-link link-small">
          {{ 'dashboard.links.gewicht' | translate }}
        </a>
      </div>
    </div>
  </ng-container>

  <!-- chart: weight -->
  <div class="chart card box mt-2 px-4">
    <h3 class="m-0 mt-3 text-center">
      {{ 'dashboard.weight_chart.headline' | translate }}
    </h3>
    <div *ngIf="timeSnap$ | async as timeSnap" class="text-center text-muted link-small">
      <em>
        {{ 'fast_lane.webk.date' | translate }}
        {{ timeSnap.timestamp | date : 'dd MMMM yyyy' }}
      </em>
    </div>
    <a
      href="/faq#gewicht"
      target="_blank"
      rel="noopener"
      class="mb-3 btn-link text-center link-small"
    >
      {{ 'dashboard.links.calculation' | translate }}
    </a>

    <ng-container *ngIf="vm$ | async as vm">
      <app-weight-change-analysis
        class="px-4"
        [weightChangePercentage]="vm.weightChangePercentage!"
        [bmi]="vm.bmi"
      ></app-weight-change-analysis>
    </ng-container>

    <app-date-picker
      class="px-4"
      [date]="date$ | async"
      (dateChange)="handleDateChange($event)"
    ></app-date-picker>
    <app-weight-chart
      class="px-4"
      [data]="weightData$ | async"
      [date]="date$ | async"
    ></app-weight-chart>
    <div class="w-100 pb-1 text-center">
      <button class="col-12 col-lg-6 btn btn-secondary btn-lg" (click)="handleOpenWeightModalClick()">
        {{ 'dashboard.weight_chart.check_weight_cta_label' | translate }}
      </button>
    </div>

    <div class="mb-3 text-center">
      <a href="/faq#gewicht" target="_blank" rel="noopener" class="btn-link link-small">
        {{ 'dashboard.links.gewicht' | translate }}
      </a>
    </div>
  </div>

  <!-- chart: basic webk -->
  <div *ngIf="(dataAvailability$ | async)?.hasBasicWebkData" class="chart card box mt-2">
    <h3 class="m-0 mt-3 text-center">
      {{ 'dashboard.survey_chart' | translate }}
    </h3>

    <div
      *ngIf="latestSubmissionDetails$ | async as submission"
      class="text-center text-muted link-small"
    >
      <em>
        {{ 'fast_lane.webk.date' | translate }}
        {{ submission.createdAt | date : 'dd MMMM yyyy' }}
      </em>
    </div>

    <a
      href="/faq#beschwerden"
      target="_blank"
      rel="noopener"
      class="mb-3 btn-link text-center link-small"
    >
      {{ 'dashboard.links.calculation' | translate }}
    </a>

    <ng-container *ngIf="latestSubmissionDetails$ | async as scoreDetails">
      <app-survey-change-analysis
        class="px-4"
        [submission]="scoreDetails"
      ></app-survey-change-analysis>
    </ng-container>

    <div #webkSection>
      <app-date-picker
        [date]="date$ | async"
        (dateChange)="handleDateChange($event)"
      ></app-date-picker>
    </div>

    <app-basic-webk-chart
      class="px-4"
      [rawData]="basicWebkData$ | async"
      [date]="date$ | async"
    ></app-basic-webk-chart>

    <div class="m-3 px-3 text-center text-muted link-small">
      <em>
        {{ 'dashboard.survey_analysis.tipp' | translate }}
      </em>
    </div>

    <ng-container *ngIf="firstAvailableSurvey$ | async as survey">
      <button
        class="btn btn-secondary align-self-center btn-lg col-12 col-lg-6 mb-1"
        [disabled]="survey.availableIn > 0"
        (click)="handleStartSurveyClick(survey)"
      >
        {{ survey.action }}
      </button>
    </ng-container>
  </div>

  <ng-container *ngIf="vm$ | async as vm">
    <div class="card box mt-2">
      <app-protein-intake
        [bmi]="vm.bmi"
        [weight]="vm.timeSnap?.weight!"
        [height]="vm.user?.coreData?.bodySizeInCm!"
      ></app-protein-intake>
    </div>
  </ng-container>

  <!-- Erfasse Deine Mahlzeit (moved under the protein card; ticket 27757) -->
  <ng-container *ngIf="vm$ | async as vm">
    <div
      *ngIf="!nutritionDiaryDisabled && vm?.user"
      id="nutrition-diary-card"
      class="card box mt-2"
    >
      <app-nutrition-diary
        [userId]="vm.user!.id"
        (success)="showSuccessMessage = true"
      ></app-nutrition-diary>
    </div>
  </ng-container>

  <!-- therapy + tumor info card (ticket: therapy type editable) -->
  <!-- TEMPORARILY DISABLED for production release: final copy and the real
       WebK therapy/tumor info links are not available yet (card still uses
       placeholder texts + a placeholder link). Re-enable once delivered. -->
  <!-- <app-therapy-info-card></app-therapy-info-card> -->

  <div class="card box mt-2">
    <app-other-nutrition-tips></app-other-nutrition-tips>
  </div>

  <div class="card box mt-2 mb-5">
    <app-need-help [isMonitoringApp]="false" (helpClicked)="handleHelpClicked()"></app-need-help>
  </div>

  <!-- previous surveys -->
  <div class="card box mt-2 mb-5 px-4">
    <h2 class="text-color my-3 text-center">
      {{ 'dashboard.previous_submissions.title' | translate }}
    </h2>

    <div class="mb-5">
      <app-survey-list
        [submissions]="submissions$ | async"
        (surveyClick)="handleGoToSurveyAnalysis($event)"
      ></app-survey-list>
    </div>
  </div>
</div>

<!-- floating action button (ticket 27757) -->
<app-dashboard-fab></app-dashboard-fab>

<!-- Global loading overlay -->
<app-async-state-overlay [processKeys]="asyncProcessKeys"></app-async-state-overlay>
